export default __webpack_public_path__ + "static/media/react.bce1eb6e.png";